const componentStatusList = [
  {
    text: 'yes',
    value: 'yes'
  },
  {
    text: 'no',
    value: 'no'
  },
  {
    text: 'notApplicable',
    value: 'not_applicable'
  }
]
const listOfFormTypes = [
  {
    text: 'Text field',
    value: 1,
    icon: 'mdi-form-textbox'
  }, {
    text: 'Text area',
    value: 2,
    icon: 'mdi-format-align-left'
  }, {
    text: 'Checkbox',
    value: 3,
    icon: 'mdi-checkbox-marked-outline'

  }, {
    text: 'Radio',
    value: 4,
    icon: 'mdi-radiobox-marked'
  }, {
    text: 'Select',
    value: 5,
    icon: 'mdi-playlist-check'
  }, {
    text: 'Date',
    value: 6,
    icon: 'mdi-calendar-today'
  }, {
    text: 'Time',
    value: 7,
    icon: 'mdi-calendar-clock'
  }, {
    text: 'Switch',
    value: 8,
    icon: 'mdi-toggle-switch-off-outline'
  }, {
    text: 'File',
    value: 9,
    icon: 'mdi-attachment'
  }, {
    text: 'Divider',
    value: 11,
    icon: 'mdi-minus'
  }, {
    text: 'Grid',
    value: 12,
    icon: 'mdi-grid'
  }, {
    text: 'Signature',
    value: 13,
    icon: 'mdi-message-draw'
  }, {
    text: 'Panel',
    value: 14,
    icon: 'mdi-view-agenda'
  }, {
    text: 'DataGrid',
    value: 18,
    icon: 'mdi-view-grid-plus'
  }, {
    text: 'HTML',
    value: 16,
    icon: 'mdi-language-html5'
  }, {
    text: 'Label',
    value: 17,
    icon: 'mdi-label-outline'
  },
  {
    text: 'Invent Component',
    value: 15,
    icon: 'mdi-newspaper-variant-outline'
  },
  {
    text: 'Survey Component',
    value: 10,
    icon: 'mdi-view-compact'
  },
  {
    text: 'Advanced Survey Component',
    value: 19,
    icon: 'mdi-view-compact'
  }
]

const standardFields = [{
  type: 1,
  name: 'Text field',
  icon: 'mdi-form-textbox'
}, {
  type: 2,
  name: 'Text area',
  icon: 'mdi-format-align-left'
}, {
  type: 3,
  name: 'Checkbox',
  icon: 'mdi-checkbox-marked-outline'
}, {
  type: 4,
  name: 'Radio',
  icon: 'mdi-radiobox-marked'
}, {
  type: 5,
  name: 'Select',
  icon: 'mdi-playlist-check'
}, {
  type: 6,
  name: 'Date',
  icon: 'mdi-calendar-today'
}, {
  type: 7,
  name: 'Time',
  icon: 'mdi-calendar-clock'
}, {
  type: 9,
  name: 'File',
  icon: 'mdi-attachment'
}, {
  type: 11,
  name: 'Divider',
  icon: 'mdi-minus'
}, {
  type: 12,
  name: 'Grid',
  icon: 'mdi-minus'
}, {
  type: 18,
  name: 'DataGrid',
  icon: 'mdi-view-grid-plus'
}, {
  type: 16,
  name: 'HTML',
  icon: 'mdi-language-html5'
}, {
  type: 17,
  name: 'Label',
  icon: 'mdi-label-outline'
}]
const advancedFields = [{
  type: 13,
  name: 'Signature',
  icon: 'mdi-message-draw',
  isAdvanced: true
}, {
  type: 14,
  name: 'Panel',
  icon: 'mdi-view-agenda',
  isAdvanced: true
},
{
  type: 10,
  name: 'Survey Component',
  icon: 'mdi-view-compact',
  isAdvanced: true
}, {
  type: 15,
  name: 'Invent Component',
  icon: 'mdi-newspaper-variant-outline',
  isAdvanced: true
}, {
  type: 19,
  name: 'Advanced Survey Component',
  icon: 'mdi-view-compact',
  isAdvanced: true
}]
standardFields.forEach(element => {
  element.isStandard = true
})
/* DataGrid Component additions */
const fieldTypeConstants = {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  LABEL: 'label',
  CHECKBOX: 'checkbox',
  SELECT: 'select',
  RADIOBOX: 'radiobox'
}
const dataGridFieldTypes = [
  {
    text: 'Text',
    value: fieldTypeConstants.STRING
  }, {
    text: 'Number',
    value: fieldTypeConstants.NUMBER
  }, {
    text: 'Checkbox',
    value: fieldTypeConstants.CHECKBOX
  }, {
    text: 'Label',
    value: fieldTypeConstants.LABEL
  }, {
    text: 'Date',
    value: fieldTypeConstants.DATE
  }, {
    text: 'Select',
    value: fieldTypeConstants.SELECT
  }, {
    text: 'Radiobox',
    value: fieldTypeConstants.RADIOBOX
  }
]
export { componentStatusList, listOfFormTypes, standardFields, advancedFields, dataGridFieldTypes, fieldTypeConstants }
